import styled from 'styled-components';

export const Layout = styled.div`
  margin-top: ${(props) => (props.snackbar ? (props.snackbarHeight ? `${props.snackbarHeight + 80}px` : '125px') : '75px')};
  @media (max-width: 600px) {
    margin-top: ${(props) => (props.snackbar ? (props.snackbarHeight ? `${props.snackbarHeight + 90}px` : '125px') : '75px')};
  }
`;

export const EnrolledCourses = styled.span`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
`;

export const Title = styled.h2`
  font-size: 16px !important;
  font-weight: 600 !important;
  margin-left: 15px;
  padding-top: 15px;
`;

export const SubTitle = styled.p`
  font-size: 15px;
  font-weight: 600;
  color: #333;
  margin: 1em;
  @media (max-width: 600px) {
    font-size: 14px;
  }
`;

export const TrialInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  background: linear-gradient(to right, var(--gradientPrimaryColor), var(--gradientSecondaryColor));
  padding: 0 10px;
`;

export const TrialInfoText = styled.p`
  color: #fff;
  margin: 10px 0;
  font-size: 15px;
  text-align: justify;
  padding: 10px 50px;
  @media (max-width: 600px) {
    font-size: 13px;
    padding: 10px;
  }
`;

export const ButtonDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const CourseContainer = styled.div`
  margin: 0 0 30px 0;
  @media (max-width: 600px) {
    margin: 0;
  }
`;

export const PremiumButtonContainer = styled.div`
  position: relative;
  top: -36px;
`;

export const MobileChangePackage = styled.div`
  display: none;
  @media (max-width: 600px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 10px 0 0 0;
    background: #fafafa;
    padding: 12px 0;
  }
`;

export const ResponseMessage = styled.div`
  padding-bottom: 8px;
  font-size: 14px;
  color: ${(props) => (props.responseStatus ? (props.darkTheme ? 'var(--highlightColor)' : 'green') : props.darkTheme ? 'var(--warning)' : 'var(--danger)')};
`;

export const FreeTag = styled.div`
  font-size: 12px;
  margin-left: ${(props) => (props.isSmallDevice ? '8px' : '2px')};
  padding: 3px;
  color: #ffffff;
  font-weight: bolder;
  background-size: 200% 100%;
  background: linear-gradient(90deg, #0000 23%, rgba(255, 255, 255, 0.3) 60%, #0000 66%) #32cd32;
  border-radius: 3px;
  animation: shine 2s infinite;
  width: max-content;
  height: fit-content;
  cursor: pointer;
`;

export const InfoBox = styled.div`
  padding: ${(props) => (props.padding ? props.padding : '15px')};
  border-radius: ${(props) => (props.borderRadius ? props.borderRadius : 'var(--buttonRadius)')};
  background-color: ${(props) => (props.background ? props.background : 'var(--siteSecondaryBgColor)')};
  color: ${(props) => (props.color ? props.color : '#4d4d4d')};
  margin: ${(props) => (props.margin ? props.margin : '')};
  @media (min-width: 576px) {
    padding: ${(props) => (props.padding ? props.padding : '20px')};
  }
`;

export const PageContainer = styled.div`
  width: 100%;
`;

// dashboard layout components
export const DboardOuterContainer = styled.div`
  --dboardSideNavWidth: 280px;
  --dboardSideNavPadding: 10px 16px;
  --dboardSideMenuNegativeWidth: -280px;
  --dboardSideMenuIconSize: 22px;
  --dboardUserSettingsHeight: 66px;
  --dboardUserSettingsBtn: 50px;
  --dboardClosedBtnHeight: 38px;
  --dboardMainXPadding: 20px;
  --dboardBottomNavHeight: 55px;

  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${(props) => props.theme.pageBg};
  @media (min-width: 481px) {
    --dboardSideNavWidth: 300px;
    --dboardSideMenuNegativeWidth: -300px;
  }
  @media (min-width: 768px) {
    --dboardMainXPadding: 55px;
  }
  @media (min-width: 992px) {
    --dboardSideNavWidth: 270px;
    --dboardSideMenuNegativeWidth: -270px;
    --dboardMainXPadding: 32px;
    flex-direction: row;
  }
  @media (min-width: 1200px) {
    --dboardMainXPadding: 48px;
  }
  @media (min-width: 1600px) {
    --dboardSideNavWidth: 280px;
    --dboardSideMenuNegativeWidth: -280px;
  }
  @media (min-width: 1800px) {
    --dboardSideNavWidth: 290px;
    --dboardSideMenuNegativeWidth: -290px;
  }
  @media (min-width: 2000px) {
    --dboardSideNavWidth: 300px;
    --dboardSideMenuNegativeWidth: -300px;
  }
`;

export const DboardMainSection = styled.main`
  flex: 1;
  width: 100%;
  max-width: 1400px;
  min-height: 100vh;
  overflow: hidden;
  background: ${(props) => props.theme.pageBg};
  margin: 0px auto;
  padding: var(--headerHeight) var(--dboardMainXPadding) calc(var(--dboardUserSettingsHeight) + 24px);
  @media (min-width: 1400px) {
    padding-bottom: calc(var(--dboardUserSettingsHeight) + 8px);
  }
`;

export const DboardMainTitle = styled.h2`
  text-align: center;
  color: ${(props) => props.theme.txtIntense};
  padding-bottom: 0px;
`;

export const DboardMainDescription = styled.p`
  text-align: center;
  color: ${(props) => props.theme.txtPrimary};
  line-height: normal;
  font-size: 14px;
  @media (min-width: 1200px) {
    font-size: 15px;
  }
`;

export const DboardSideNotification = styled.div`
  display: none;
  @media (min-width: 1400px) {
    display: block;
    width: var(--dboardSideNavWidth);
    height: 100vh;
    padding: 80px 20px 60px;
    overflow-y: auto;
    position: sticky;
    top: 0px;
    z-index: 1;
    background-color: ${(props) => props.theme.pageBg};
    border-left: 1px solid ${(props) => props.theme.borderColor};
  }
  &::-webkit-scrollbar {
    width: 4px;
    display: block;
  }
  &::-webkit-scrollbar-thumb {
    background: transparent;
  }
  &:hover::-webkit-scrollbar-thumb {
    background: ${(props) => (props.darkTheme ? '#ffffff1a' : '#d2e3ff')};
  }
`;

// Dboard section styles
export const DboardSectionTitle = styled.h2`
  color: ${(props) => props.theme.txtIntense};
`;

// myCourses components
export const LatestModuleContainer = styled.div`
  width: 100%;
  padding: 20px;
  display: grid;
  grid-template-columns: auto;
  @media (min-width: 576px) {
    grid-template-columns: 38% auto;
  }
  @media (min-width: 768px) {
    grid-template-columns: 40% auto;
  }
  @media (min-width: 992px) {
    grid-template-columns: 35% auto;
  }
  @media (min-width: 1200px) {
    grid-template-columns: 30% auto;
  }
`;

export const LatestModuleImgWrapper = styled.div`
  width: 100%;
  max-width: 320px;
  @media (min-width: 576px) {
    max-width: unset;
  }
`;

export const LatestModuleContentWrapper = styled.div`
  padding-top: 10px;
  @media (min-width: 576px) {
    padding-top: unset;
    padding-left: 16px;
  }
  @media (min-width: 1400px) {
    padding-top: 8px;
    padding-left: 24px;
  }
  @media (min-width: 1800px) {
    padding-left: 32px;
  }
`;

export const LatestModuleCourseName = styled.p`
  font-size: 14px;
  color: ${(props) => props.theme.txtPrimary};
`;

export const LatestModuleTitle = styled.div`
  font-family: var(--headingFont);
  font-weight: 500;
  font-size: 15px;
  padding-bottom: 8px;
  color: ${(props) => props.theme.txtPrimary};
  @media (min-width: 576px) {
    font-size: 16px;
  }
`;

export const LatestModuleDescription = styled.p`
  color: ${(props) => props.theme.txtSecondary};
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  @media (min-width: 992px) {
    font-size: 14px;
  }
`;

export const LatestModuleLeftContent = styled.div`
  @media (min-width: 576px) {
    padding-left: 16px;
  }
`;

export const LatestModuleRightContent = styled.div`
  @media (min-width: 576px) {
    padding-left: 16px;
  }
`;

// select container
export const DboardCoursesSelectConatiner = styled.div`
  display: grid;
  justify-content: center;
  padding-bottom: 24px;
  @media (min-width: 992px) {
    grid-template-columns: ${({ noSelection }) => !noSelection && 'auto 324px'};
    column-gap: ${({ noSelection }) => !noSelection && '10px'};
    align-items: center;
  }
`;

export const DboardSelectHeading = styled.h2`
  padding-bottom: unset;
  color: ${(props) => props.theme.txtIntense};
  font-size: 20px !important;
  @media (min-width: 481px) {
    font-size: 22px !important;
  }
  @media (min-width: 768px) {
    font-size: 24px !important;
  }
`;

export const MyCoursesSelectWrapper = styled.div`
  width: 100%;
  max-width: 300px;
  position: relative;
  border-radius: var(--buttonRadius);
  color: ${(props) => props.theme.inputsColor};
  background-color: ${(props) => props.theme.cardBg};
  border: 1px solid ${(props) => props.theme.borderColor};
  cursor: pointer;
  margin-top: ${(props) => props.secondarySelection && '16px'};
  @media (min-width: 576px) {
    margin-top: ${(props) => props.secondarySelection && 'unset'};
    margin-left: ${(props) => props.secondarySelection && '16px'};
  }
`;

export const TrialVideosSelectWrapper = styled.div`
  width: 100%;
  max-width: 300px;
  position: relative;
  border-radius: var(--buttonRadius);
  color: ${(props) => props.theme.inputsColor};
  background-color: ${(props) => props.theme.cardBg};
  border: 1px solid ${(props) => props.theme.borderColor};
  cursor: pointer;
  @media (min-width: 576px) {
    width: max-content;
  }
`;

export const DboardSelect = styled.select`
  width: 100%;
  border: none;
  border-radius: inherit;
  color: inherit;
  background: inherit;
  outline: none;
  padding: 5px 30px 5px 10px;
  appearance: none;
  cursor: pointer;
`;

export const CategoryDivisionWrapper = styled.div`
  max-width: 320px;
  margin-top: 8px;
  margin-bottom: 12px;
  border-bottom: 1px solid ${({ darkTheme }) => (darkTheme ? 'var(--dark)' : 'var(--greyShadowColor)')};
  @media (min-width: 992px) {
    margin-top: unset;
  }
`;

export const CategoryTabsDivision = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  &:after {
    position: absolute;
    display: block;
    left: ${({ selectedTab }) => (selectedTab === 'firstTab' ? '0%' : '50%')};
    bottom: -1px;
    content: '';
    width: 50%;
    height: 2px;
    background: var(--brandColor);
    transition: left var(--hoverTransitionDuration);
  }
`;

export const CategoryTab = styled.div`
  width: 50%;
  height: 35px;
  padding: 0px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  align-content: center;
  font-size: 15px;
  font-family: var(--headingFont);
  font-weight: ${({ active }) => (active ? 500 : 400)};
  color: ${({ active, darkTheme, nonclickable }) =>
    nonclickable && darkTheme
      ? 'var(--secondary)'
      : nonclickable
      ? 'var(--greyColor)'
      : active && darkTheme
      ? '#f1f1f1'
      : active
      ? 'var(--inputTxtColor)'
      : darkTheme
      ? '#d1d1d1'
      : 'var(--normalTxtColor)'};
  background: ${(props) => props.theme.pageBg};
  cursor: ${({ nonclickable }) => (nonclickable ? 'default' : 'pointer')};
`;

export const TrialVideoImgWrapper = styled.div`
  position: relative;
  border-radius: var(--buttonRadius);
  overflow: hidden;
  &:hover > .trial-play-icon {
    opacity: 0.85;
    transition: opacity 0.3s ease;
  }
`;

export const TrialModuleName = styled.p`
  font-size: 14px;
  padding: 5px 0px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${(props) => props.theme.txtPrimary};
`;

// myCourses styles

export const MyCoursesCourseCard = styled.div`
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  background-color: ${(props) => (props.darkTheme ? props.theme.cardInnerBg : '#fff')};
  box-shadow: ${(props) => !props.darkTheme && '0px 1px 4px var(--greyShadowColor)'};
`;

export const MyCoursesSpecialGroup = styled.h4`
  width: fit-content;
  font-size: 15px !important;
  padding: 8px 12px !important;
  color: ${(props) => props.theme.txtIntense};
  background-color: ${(props) => props.theme.selectionBg};
  border-radius: 20px;
  @media (min-width: 481px) {
    font-size: 16px !important;
    padding: 8px 20px !important;
    margin: 0px;
  }
`;

export const DboardCourseCardName = styled.p`
  padding: 10px;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${(props) => props.theme.txtPrimary};
`;

export const DboardCourseBottomDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  padding: 0px 10px 10px;
  @media (min-width: 481px) {
    align-items: ${({ isFree }) => isFree && 'start'};
  }
`;

export const DboardCoursePriceDiv = styled.div`
  display: flex;
  flex-direction: column;
  @media (min-width: 1600px) {
    flex-direction: row;
    align-items: center;
  }
`;

export const CourseListPrice = styled.del`
  color: ${(props) => props.theme.txtSecondary};
  font-family: var(--headingFont);
  font-size: 13px;
  line-height: 1;
  @media (min-width: 768px) {
    font-size: 14px;
  }
  @media (min-width: 1600px) {
    font-size: 15px;
  }
`;

export const CourseOfferPrice = styled.span`
  color: ${(props) => props.theme.txtIntense};
  font-family: var(--headingFont);
  font-weight: 600;
  font-size: 16px;
  line-height: 1;
  padding-top: 6px;
  @media (min-width: 768px) {
    font-size: 18px;
  }
  @media (min-width: 1600px) {
    padding-top: unset;
    padding-left: 8px;
    font-size: 20px;
  }
`;

export const DboardCourseButtonDiv = styled.div`
  padding-left: 8px;
  & button {
    width: 110px;
    height: 34px;
  }
`;

export const ModuleProgressText = styled.p`
  font-family: var(--headingFont);
  font-size: 12px;
  color: ${(props) => props.theme.txtSecondary};
  padding-bottom: 4px !important;
`;

// certificate section
export const SampleCertificateHeading = styled.h4`
  color: ${(props) => props.theme.txtIntense};
  padding-bottom: 1rem;
`;

export const CertificateCourseTitle = styled.p`
  color: ${(props) => props.theme.txtPrimary};
  font-size: 15px;
  padding-top: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-wrap: nowrap;
`;

export const CertificateDownloadBtn = styled.button`
  position: absolute;
  right: 4px;
  top: 4px;
  padding: 2px 6px;
  border-radius: 2px;
  color: ${(props) => props.theme.txtIntense};
  background-color: ${(props) => (props.darkTheme ? '#333333ad' : 'var(--siteBorderColor)')};
  &:hover {
    opacity: 0.9;
  }
`;

export const CertificateLinkedinBtn = styled.button`
  position: absolute;
  right: 4px;
  bottom: 4px;
  padding: 3px 6px;
  border-radius: 2px;
  display: flex;
  color: ${(props) => props.theme.txtIntense};  
  background-color: ${(props) => (props.darkTheme ? '#333333ad' : 'var(--siteBorderColor)')};
  }
  &:hover {
    opacity: 0.9;
`;

export const CertificateOverlay = styled.div`
  opacity: 0.7;
  position: absolute;
  background-color: ${(props) => (props.darkTheme ? '#0000009e' : '#f8f9fa')};
  top: 0px;
  left: 50%;
  width: 101%;
  height: 101%;
  align-items: center;
  justify-content: center;
  display: flex;
  transform: translateX(-50%);
  text-align: center;
`;

// referral section
export const ReferralList = styled.li`
  font-size: 14px;
  padding-inline-start: 4px;
  padding-bottom: 8px;
  color: ${(props) => props.theme.txtPrimary};
  @media (min-width: 992px) {
    font-size: 15px;
  }
`;

export const ReferralLinkBox = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  padding: 10px 15px;
  font-weight: 500;
  color: var(--greyBgLight);
  background-color: ${(props) => (props.darkTheme ? 'var(--dark)' : 'var(--brandColor)')};
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  border-bottom: 2px dashed var(--greyBgLight);
  box-shadow: ${(props) => !props.darkTheme && '0 1px 8px var(--blueShadowColor)'};
  overflow-wrap: anywhere;
  @media (min-width: 576px) {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    border-top-right-radius: 0px;
    border-right: 2px dashed var(--greyBgLight);
    border-bottom: none;
  }
`;

export const ReferralLinkBtn = styled.button`
  flex: 0.1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  padding: 8px 15px;
  color: ${(props) => (props.isCopied ? 'var(--light)' : props.darkTheme ? 'var(--dark)' : 'var(--brandColor)')};
  background-color: ${(props) => (props.isCopied ? (props.darkTheme ? 'var(--dark)' : 'var(--brandColor)') : 'var(--light)')};
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
  border: ${(props) => !props.darkTheme && '2px solid var(--brandColor)'};
  border-top: none;
  transition: 0.2s;
  @media (min-width: 576px) {
    border-bottom-right-radius: 8px;
    border-top-right-radius: 8px;
    border-bottom-left-radius: 0px;
    border-left: none;
    border-top: ${(props) => !props.darkTheme && '2px solid var(--brandColor)'};
  }
  &:hover {
    transition: 0.2s;
    filter: ${(props) => !props.isCopied && 'brightness(95%)'};
  }
`;

export const ReferralAnalyticsBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  color: ${(props) => props.theme.txtPrimary};
  background-color: ${(props) => props.theme.cardBg};
  padding: 15px;
  border-radius: var(--buttonRadius);
  box-shadow: ${(props) => !props.darkTheme && '0px 1px 6px var(--greyBorderColor)'};
`;

export const ReferralInnerDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  padding: 5px 15px;
  &:nth-child(1) {
    border-bottom: 1px solid ${(props) => props.theme.borderColor};
  }
  &:nth-child(2) {
    border-bottom: 1px solid ${(props) => props.theme.borderColor};
  }
  &:nth-child(3) {
    border-bottom: 1px solid ${(props) => props.theme.borderColor};
  }
  @media (min-width: 576px) {
    &:nth-child(1) {
      border-right: 1px solid ${(props) => props.theme.borderColor};
    }
    &:nth-child(1),
    &:nth-child(2) {
      max-width: 50%;
    }
  }
  @media (min-width: 992px) {
    max-width: 33.33% !important;
    &:nth-child(2) {
      border-right: 1px solid ${(props) => props.theme.borderColor};
    }
  }
`;

export const ReferralFormHeading = styled.h4`
  color: ${(props) => props.theme.txtIntense};
  font-size: 18px !important;
  padding-bottom: 8px;
  @media (min-width: 576px) {
    font-size: 20px !important;
  }
  @media (min-width: 768px) {
    font-size: 22px !important;
    padding-bottom: 16px;
  }
  @media (min-width: 992px) {
    font-size: 24px !important;
  }
  @media (min-width: 1200px) {
    font-size: 26px !important;
  }
  @media (min-width: 1400px) {
    font-size: 28px !important;
  }
`;

export const ReferralFormDescription = styled.p`
  color: ${(props) => props.theme.txtPrimary};
  font-size: 14px;
  @media (min-width: 992px) {
    font-size: 16px;
  }
`;

export const ReferralForm = styled.div`
  position: relative;
  width: 100%;
  max-width: 360px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: var(--buttonRadius);
  background-color: ${(props) => props.theme.cardBg};
  box-shadow: ${(props) => !props.darkTheme && '0px 2px 10px var(--greyBorderColor)'};
  @media (min-width: 481px) {
    max-width: 380px;
    padding: 30px;
  }
  @media (min-width: 1200px) {
    max-width: 420px;
  }
`;
